<template>
    <div ref="dropdownWrapper">
        <div v-if="getActions().length > 0" class="relative flex justify-end">
            <button class="focus:outline-none" @click="toggleDropdown">
                <img src="../../../assets/images/vertical-dot-icon.png" alt="Up Down Arrow" class="w-[30px] h-[30px]" />
            </button>

            <ul v-if="isOpen"
                class="absolute top-[25px] right-0 z-10 mt-1 w-[200px] bg-white rounded shadow-lg text-[#333333] text-[15px] font-roboto py-[5px] overflow-hidden">
                <li v-for="option in getActions()" :key="option" @click="select(option)"
                    class="px-2 py-[5px] mx-[10px] my-[5px] rounded-md hover:bg-customYellow-100 hover:text-white cursor-pointer text-left">
                    {{ option }}
                </li>
            </ul>
        </div>
        <div v-else class="relative flex mr-4 justify-end">
            -
        </div>
    </div>
</template>

<script>
export default {
    name: "ActionDropdown",

    props: ["item"],

    data() {
        return {
            isOpen: false,
            user: JSON.parse(localStorage.getItem("user")) ?? null
        };
    },

    mounted() {
        document.addEventListener("click", this.handleClickOutside);
    },

    unmounted() {
        document.removeEventListener("click", this.handleClickOutside);
    },

    methods: {

        getActions() {
            let res = []
            if (this.user?.user?.user_id == this.item.parent_id) {
                res.push("Edit")

                if (this.item.active != '1') {
                    res.push("Active")
                }
                else {
                    res.push("Inactive")
                }
            }
            return res
        },

        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },

        select(option) {
            this.$emit("select", option); // parent ko notify karega
            this.isOpen = false;
        },

        handleClickOutside(e) {
            if (this.$refs.dropdownWrapper && !this.$refs.dropdownWrapper.contains(e.target)) {
                this.isOpen = false;
            }
        },
    },
};
</script>
